import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Planzone, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  resources: Identifiable<Resource>[];
  retrievePlanzoneResources(
    request: Boundaries["retrievePlanzoneResources"]["request"],
  ): void;
}

function useRetrievePlanzoneResources(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isPlanzoneResourcesRetrievalRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isPlanzoneResourcesRetrievalRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isPlanzoneResourcesRetrievalRequestFailure,
    ),
    resources: useSelector(selector.getPlanzoneResources),
    retrievePlanzoneResources: core.retrievePlanzoneResources,
  };
}

export { useRetrievePlanzoneResources };
